
<template>
    
        <mars-view class="other-question"><mars-view class="other-question-title">
        您还可以试试搜索
    </mars-view><mars-view v-if="type === 'regulation'" class="quiz"><mars-view v-for="(item, index) in regulationList" :key="index" class="other-quiz-item c-line-clamp1" @click.native="searchRegulationQuestion(item)">
            {{ item.text }}
        </mars-view></mars-view><mars-view v-else class="question"><mars-view v-for="(item, index) in qaList" :key="index" class="other-question-item c-line-clamp1" @click.native="searchQaQuestion(item)">
            {{ item.text }}
        </mars-view></mars-view><mars-view class="regulation-online-consult-card"><online-consult-card v-if="lawyerCount && bannerAd.type" :lawyer-count="lawyerCount" :ad-type="bannerAd.type" :ad-url="bannerAd.url" page-form="regulations"></online-consult-card><mars-view class="join-box"><join-entrance fr="sp-flfg-js-3"></join-entrance></mars-view></mars-view></mars-view>
    
</template>

<script>
import onlineConsultCard from "../../../components/common/onlineConsultCard.vue";
import joinEntrance from "../../common/joinEntrance.vue";
export default {
  components: {
    'online-consult-card': onlineConsultCard,
    joinEntrance
  },
  props: {
    regulationList: {
      type: [Array, Object],
      default() {
        return [];
      }
    },
    qaList: {
      type: [Array, Object],
      default() {
        return [];
      }
    },
    type: {
      type: String,
      default() {
        return '';
      }
    },
    lawyerCount: {
      type: String,
      default: ''
    },
    bannerAd: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    searchRegulationQuestion(item) {
      this.$emit('searchRegulationQuestion', item.query);
    },
    // 搜索对应qa的推荐数据
    searchQaQuestion(item) {
      this.$emit('searchQaQuestion', item.query);
    }
  }
};
</script>

<style scoped>
.other-question {
  background: rgba(68, 95, 187, 0.04);
  border-radius: 13px;
  padding: 30px 17px;
  margin: 10px 17px 0;
}
.other-question .other-question-title {
  font-size: 19px;
  line-height: 19px;
  font-weight: 700;
  text-align: center;
  padding-bottom: 15px;
}
.other-question .quiz {
  display: flex;
  flex-wrap: wrap;
}
.other-question .other-quiz-item {
  box-sizing: border-box;
  color: #445fbb;
  width: 50%;
  text-align: left;
  line-height: 37px;
  padding-right: 4px;
}
.other-question .other-question-item {
  color: #445fbb;
  width: 100%;
  line-height: 37px;
  text-align: left;
}
.other-question .regulation-online-consult-card {
  margin-top: 30px;
}
.other-question .regulation-online-consult-card /deep/ .banner-ad-title,
.other-question .regulation-online-consult-card [class*='__banner-ad-title'] {
  font-size: 0.16rem;
  text-align: center;
}
.other-question .regulation-online-consult-card .join-box {
  margin-top: 0.48rem;
}

</style>
